<ion-app class="app">
  <div class="main" [ngClass]="mainClasses()">
    <app-navbar></app-navbar>
    <div class="main-container">
      <app-left-side-bar></app-left-side-bar>
      <div class="content">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>

  <div class="appLoader" [ngClass]="appLoaderClasses()">
    @if (!appLoaderState().hasApiFailed) {
      <ion-spinner name="circular" color="#fff"></ion-spinner>
      <p>{{ messages.APP_LOADING }}</p>
    } @else {
      <ion-icon name="alert-circle-outline" size="large"></ion-icon>
      <p>{{ error || messages.API_ERROR }}</p>
      <ion-button class="error-button" fill="clear" (click)="retryApiCalls()"> {{ messages.RETRY_BUTTON }}</ion-button>
    }

  </div>
</ion-app>
